/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "우정 허브",
      "Bumble For Friends 앱과 함께 새로운 친구들을 찾으세요 | Bumble",
      "App Store에서 다운받기",
      "Google Play에서 다운받기",
      "새로운 친구를 만들기 위한 장소입니다",
      "진실한 인연을 위해 근처에 있는 사람들을 발견하세요",
      "인생의 어떤 단계에서든 만날 친구를 찾으세요",
      "새로 이사 오셨나요? 새로운 출발을 계획 중인가요? 새로운 친구들이 회원님을 기다리고 있어요!",
      "모두를 위한 안전한 공간",
      "회원님이 스스로가 될 수 있는 친절한 인터넷 공간에 오신 것을 환영합니다.",
      "앱 다운로드",
      "공통 관심사를 갖고 있는 사람들을 실제로 만나보세요!",
      "Bumble For Friends의 Plans에서 새로운 그룹의 사람들을 알아보세요",
      "Plans에 초대를 받으셨어요",
      "Plans는 Bumble For Friends에서 근처에 있는 친구들과 계획을 만들고 만날 수 있는 기능입니다",
      "쿠키 관리",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "일"
            ],
            "singular": [
                  "일"
            ]
      },
      "hour": {
            "plural": [
                  "시간"
            ],
            "singular": [
                  "시간"
            ]
      },
      "minute": {
            "plural": [
                  "분"
            ],
            "singular": [
                  "분"
            ]
      },
      "month": {
            "plural": [
                  "개월"
            ],
            "singular": [
                  "개월"
            ]
      },
      "second": {
            "plural": [
                  "초"
            ],
            "singular": [
                  "초"
            ]
      },
      "year": {
            "plural": [
                  "년"
            ],
            "singular": [
                  "년"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
